import { render, staticRenderFns } from "@/manager/budget/views/generate-remittance-modal/generate-remittance-modal.pug?vue&type=template&id=c5bdc8a6&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bdc8a6",
  null
  
)

export default component.exports